import { render, staticRenderFns } from "./Wastes.vue?vue&type=template&id=5bbefbe8&scoped=true&"
import script from "./Wastes.vue?vue&type=script&lang=js&"
export * from "./Wastes.vue?vue&type=script&lang=js&"
import style0 from "./Wastes.vue?vue&type=style&index=0&id=5bbefbe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbefbe8",
  null
  
)

export default component.exports